import { Component, effect, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
import { RealmService } from './keycloak/services/realm.service';
import { BootstrapService } from './shared/services/bootstrap.service';
import { ThemeService } from './shared/services/theme.service';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmDialog],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly bootstrapService = inject(BootstrapService);
  readonly themeService = inject(ThemeService);

  constructor() {
    const keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
    const realmService = inject(RealmService);

    effect(async () => {
      const keycloakEvent = keycloakSignal();

      if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
        await realmService.clearStorage();
      }
    });
  }

  ngOnInit(): void {
    this.bootstrapService
      .initApplicationData()
      .catch((error) => console.error('Failed to initialize application data:', error));
  }
}
